import React, { Component } from 'react';
import 'antd/dist/antd.css';
import '../App.css';
import { render } from '@testing-library/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import firebaseConfig from "../config"
import { Avatar, Tooltip, Button  } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
class Header extends Component{

    state={
        imgsrc: null,
        isloggedin: null
    }

componentDidMount(){

    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            
            console.log(user.displayName)
            console.log(user)
            console.log(user.photoURL)

            this.setState({
                imgsrc: user.photoURL,
                isloggedin: true
            })


        } else {
          // No user is signed in.
        }
      });



}

decoco = e =>{

    
  firebase.auth().signOut().then(() => {
    
    document.location.reload(true)

  }).catch(function(error) {
    // An error happened.
  });
}


showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };


  
connexion = e =>{

    var provider = new firebase.auth.TwitterAuthProvider();
    firebase.auth().languageCode = 'fr';
  // To apply the default browser preference instead of explicitly setting it.
  // firebase.auth().useDeviceLanguage();
  provider.setCustomParameters({
    'lang': 'fr'
  });
  
  
  firebase.auth().signInWithPopup(provider).then((result) => {
    // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
    // You can use these server side with your app's credentials to access the Twitter API.
    var token = result.credential.accessToken;
    var secret = result.credential.secret;
    // The signed-in user info.
    var user = result.user;
    
  
  
  
  
  
  
    this.setState({
      etape: 2
    })
  
  
  }).catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    // ...
  });
  
  
  }

  
render(){
    const text = <span>Deconnexion</span>;

    const buttonWidth = 70;
    return(
<div>

{this.state.isloggedin == true && <div className="Headerlogo"> 
        <label className="decobutton" onClick={this.decoco}>Deconnexion</label>
        <span className="ant-avatar ant-avatar-circle ant-avatar-image hehetetehehe1"><img className="imgdisplay" src={this.state.imgsrc}></img></span>
</div>}

{this.state.isloggedin == null && 
    <div className="Headerlogo">
        <label className="cobutton" onClick={this.showModal}>Se connecter</label>

        <Modal
          title="Se connecter"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          okText=" "
          cancelText="cancel"
        >

<button className="button_connexion" onClick={this.connexion}><img className="twitterlogobutton" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/twitter_PNG15.png?alt=media&token=5e474f5f-f84f-45a6-aa12-d4ad05f6d021"></img>Connexion avec Twitter</button>

        </Modal>
    </div>
    
    
    
    
    }
</div>

    )
}







}

export default Header